import { Injectable } from '@angular/core';
import { GuiFlowService } from '../../__gui/gui-flow.service';

@Injectable({
  providedIn: 'root'
})
export class VisaDataProviderService {

  requisitosVisado = {
    cardId: 'D',
    title: 'Requisitos para el Visado de Estudios',
    imageUrl: '../../assets/images/components/mobile/image1.png',
    longPar: '',
    longParLimit: '',
    shortPara: '',
    dataArray: [
      /* No sé si estás aplican (15/04/2024) {
        req: 'Poder Generalísimo para Padre o Madre',
        link: ''
      },
      {
        req: 'Constancia médica de la buena salud del solicitante, mediante presentación de informe o certificado médico.',
        link: ''
      },
      {
        req: 'Certificado de notas de Universidad',
        link: ''
      } */
      {
        title: 'Pasaporte',
        description: 'Pasaporte (con validez mínima de 6 meses previo a la fecha de vencimiento).El pasaporte le será devuelto inmediatamente después de presentar la solicitud. ',
      },
      {
        title: 'Copia pasaporte',
        description: 'Fotocopia del pasaporte válido y en vigor	original.'
      },
      {
        title: 'Formulario Solicitud del visado',
        description: 'Formulario de solicitud del visado',
        button: 'Formulario de solicitud del visado',
        buttonLink: 'formularioVisado' 
      },
      {
        title: 'Fotografía',
        description: 'Dos fotografía reciente, tamaño carné (3x4 cm), tomada de frente, con la cara descubierta con fondo completamente blanco.'
      },
      {
        title: 'Comprobante admisión centro estudios en España. (carta de admisión)',
        description: 'En el certificado deberá constar: Nombre del centro de Estudios, dirección fisica, fecha de inicio y finalización de los estudios. (solicitar a la Universidad o centro de estudios).'
      },
      {
        title: 'Pagos realizados',
        description: 'Documentación sobre costo de los estudios y pagos realizados	Certificado/documento que indique lo que se ha pagado hasta el momento, y los desgloces de los pagos. (solicitar a la Universidad o centro de estudios).'
      },
      {
        title: 'Plan de Estudios, formación o investigación',
        description: 'Documentación sobre el contenido del plan de estudios.	Indicar fecha de inicio y especificación del total de horas lectivas semanales de que consta el curso o la actividad a realizar (solicitar a la Universidad o centro de estudios).'
      },
      {
        title: 'Título Universitario',
        description: 'Título oficial o asignaturas convalidadas de los estudios cursados anteriormente	Solicitar a la Universidad o centro de estudios en Costa Rica (o el país de procedencia). Apostillado por casa Amarilla'
      },
      {
        title: 'Prueba de medios económicos',
        description: 'Se debe aportar la documentación que demuestre que se cuenta con los recursos económicos suficientes para cubrir durante el período solicitado: la subsistencia, alojamiento y, en su caso, para garantizar el retorno a Costa Rica. La cantidad mínima exigida equivale al 100% del IPREM (Indicador Público de Renta de Efectos Múltiples. El monto ronda los 580 Euros mensuales. Se puede demostrar de las siguientes formas:',
        sublist: [
          'Certificado de concesión de becas y/o créditos educativos.',
          'Certificado notarial en donde el familiar o allegado declara que va a hacerse cargo de los gastos del solicitante. En caso de seleccionar esta última opción, se deben aportar los estados de cuenta bancaria de los últimos tres meses, emitidos y sellados por el banco, indicando el nombre completo del titular de la cuenta y la moneda.'
        ]
      },
      {
        title: 'Tasa',
        description: 'Pago de la tasa para Visado	Se debe de pagar al momento de presentar la solicitud (en la Embajada) pero para los costarricenses es un trámite gratuito.'
      },
      {
        title: 'Certificado médico (emitido por el colegio de médicos)',
        description: 'Para cuando la duración de los estudios supere los seis meses. Este documento acredita que el solicitante no padece ninguna de las enfermedades que pudieran tener repercusiones de Salud Pública graves de con conformidad con los dispuesto en el R.S.I. de 2005. El certificado médico se debe de obtener con un médico inscrito en el Colegio de Médicos de Costa Rica. Posteriormente hay que llevar ese certificado al Colegio de Médicos acreditando al médico firmante y finalmente tiene que ser Apostillado por casa Amarilla'
      },
      {
        title: 'Certificado de antecedentes penales',
        description: 'Certificado de antecedentes penales internacional: Para cuando la duración de los estudios supere los seis meses y solo para mayores de edad. Se solicita para "uso internacional".'
      },
      {
        title: 'Seguro médico internacional',
        description: 'Seguro de enfermedad: Para cuando la duración de los estudios supere los seis meses. Se debe pedir una carta a la empresa aseguradora donde acredite que posee cobertura médica. El seguro debe cubrir todos los riesgos asegurados por el sistema público de salud en España y tiene que tratarse de seguros de salud (no de viaje)',
        callToActionButton: 'Contratar seguro médico',
        callToActionLink: 'hireHealthInssurance',
      }
      /* Para ello, se debe aportar alguno de los siguientes documentos: 
      Se puede sacar de 3 maneras: - En el Registro Judicial en San José (edificio Anexo A del Poder Judicial). El horario de atención es de lunes a viernes de 7:30 a.m. a 4:30 p.m y dan el documento el mismo dia.                                                                                                                                                                                                       - Completando el formulario en el sitio web del Poder Judicial (www.poder-judicial.go.cr), indicando la oficina donde desea retirarla en los próximos cinco días hábiles.
          - En las Administraciones Regionales. Consultar los horarios de atención para este trámite.

      */
    ]
  };

  conectandoConLaU = {
    cardId: 'Icon',
    title: 'Conectando con las Universidades',
    imageUrl: this.guiFlow.getImage('82448730-e842-4644-a758-64278c757500','public'),
    longPar: 'Estos son algunos de los puntos en los que te podremos ayudar cuando tengas ganas de comenzar con tu proceso de encontrar el plan de estudios más adecuado para ti.',
    longParLimit: '300',
    shortPara: '',
    iconSize: 'md',
    dataArray: [
      {
        description: '¿Cómo hago el primer acercamiento/contacto?',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-comments'
      },
      {
        description: 'Principales universidades de España.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-university'
      },
      {
        description: 'Centros de estudio.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-school'
      },
      {
        description: 'Costos de matrícula y pagos.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-file-invoice-dollar'
      },
      {
        description: 'Carta de aceptación.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-file-contract'
      },
      {
        description: 'Calendario académico (inicio-fin del curso lectivo).',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-calendar-alt'
      },
      {
        description: '¿Cómo llegar? ¿Cuánto se tarda desde mi casa al centro de estudios?',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-route'
      },
      {
        description: 'Becas (CONAPE y casa amarilla).',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-hand-holding-usd'
      }
    ]
  };

  checks = {
    cardId: 'Checks',
    title: 'Notas importantes',
    imageUrl: '../../assets/voyjaleas/userApp/health.png',
    longPar: '',
    longParLimit: '',
    shortPara: '',
    iconSize: 'md',
    dataArray: [
      {
        description: 'De todos los documentos se deberá presentar 1 documento original y 1 copia.',
      },
      {
        description: 'La solicitud del Visado de Estudiante ante la Embajada se puede iniciar con una antelación de 3 meses (no más) para el comienzo de las clases, y se presenta tras sacar cita en la web de la Embajada de España.',
      },
      {
        description: 'Desde el 10 de Mayo de 2021 es obligatorio solicitar cita previa para realizar la apostilla de documentos en la Casa Amarilla. Los timbres para los documentos se pueden comprar en Casa Amarilla, en la misma oficina donde se presentan los documentos a apostillar.',
      },
      {
        description: 'Cita del visado (Visados > Solicitud de visado)',
        link: 'https://www.exteriores.gob.es/Embajadas/sanjosedecostarica/es/Paginas/index.aspx '
        // https://www.exteriores.gob.es/DocumentosAuxiliaresSC/Costa%20Rica/SAN%20JOS%C3%89%20DE%20COSTA%20RICA%20(E)/SOLICITUD%20CITA%20DE%20VISADO%20DE%20ESTUDIOS.pdf
      },
      {
        description: 'Cita apostilla (Casa Amarilla)',
        link: 'https://www.rree.go.cr/?sec=servicios&cat=autenticaciones&cont=734'
      },
      {
        description: 'Hoja de delincuencia (Poder Judicial)',
        link: 'https://pjenlineacr.poder-judicial.go.cr/sacejenlinea/ '
      }
    ]
  };

  introSection = {
    cardTitle: 'Todo lo que necesitas saber si vas a estudiar en España',
    titleTag: 'Introducción',
    cardId: 'Intro',
    imageUrl: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/14a63405-3200-4465-7e74-75196b884f00/public',
    imageSize: 'md',
    category: 'Visa',
    title: 'Estudios en España',
    description: 'Nuestro objetivo es facilitarte el camino para que puedas enfocarte en tu educación y experiencia en este hermoso país. No dudes en explorar esta sección para obtener información detallada y asesoramiento personalizado sobre las visas de estudiante en España.',
    longPar: 'En esta sección de nuestra aplicación web, te brindamos toda la información necesaria sobre las visas de estudiante para aquellos que desean estudiar en España. Te ayudamos a comprender los requisitos, el proceso de solicitud y los documentos necesarios para obtener tu visa de estudiante en España.',
    longParLimit: '400',
    shortPara: '',
    actionButtons: [
      {
        label: 'Guía',
        icon: 'fas fa-file-import icon',
      },
      {
        label: 'Requisitos',
        icon: 'fas fa-file-alt icon',
      },
      {
        label: 'Plazos',
        icon: 'fas fa-calendar-check icon',
      }
    ],
    listData: []
    
  };

  constructor(private guiFlow: GuiFlowService) { }

  getRequisitosVisados(){
    return this.requisitosVisado;
  }

  getConectandoConLaU(){
    return this.conectandoConLaU;
  }

  getChecks(){
    return this.checks;
  }

  getIntro(){
    return this.introSection;
  }

}
